import commitMutation from 'relay-commit-mutation-promise';
import { graphql } from 'react-relay';

const mutation = graphql`
    mutation ModifyPortfolioItems_esMutation($input: ModifyPortfolioItemsInput!) {
        modifyPortfolioItems(input: $input) {
            portfolio {
                id
            }
        }
    }
`;

function getVariables(args) {
    const {
        action,
        endPortfolioItemId,
        itemsIds,
        note,
        portfolioId,
        portfolioItemsIds,
        startPortfolioItemId,
        targetPortfolioItemId,
        userId,
    } = args;
    if (action === 'REMOVE') {
        return { action, portfolioItemsIds, portfolioId, userId };
    } else if (action === 'ADD') {
        return { action, itemsIds, portfolioId, userId };
    } else if (action === 'REORDER') {
        return {
            action,
            endPortfolioItemId,
            startPortfolioItemId,
            targetPortfolioItemId,
            portfolioId,
            userId,
        };
    } else if (action === 'EDIT') {
        return {
            action,
            itemsIds,
            note,
            portfolioId,
            portfolioItemsIds,
            userId,
        };
    }
    return null;
}

function commit(environment, args) {
    const variables = {
        input: getVariables(args),
    };
    return commitMutation(environment, {
        mutation,
        variables,
    });
}

export default { commit };
